import React from 'react';
import { Modal as MaterialModal } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import Button from 'src/components/Button/Button';

interface AutoTransactionModalProps {
  onClose: () => void,
  balance: number,
  onApprove: () => void,
  // eslint-disable-next-line no-unused-vars
  setAmount: (e: any) => void,
  setSelectedTill: Function,
  requireProperties: boolean,
  tillOptions: { id: number, codePath: string, name: string, code: number }[],
  transactionName: string
}

function AutoTransactionModal({ onClose,
  onApprove,
  setAmount,
  setSelectedTill,
  requireProperties=false,
  tillOptions,
  transactionName
}: AutoTransactionModalProps) {
  const { t } = useTranslation();

  return (
    <MaterialModal
      disableEscapeKeyDown={ true }
      open={ true }
      onClose={ onClose }
      className="modal"
    >
      <div className="modal-container">
        <div className="cancel-ticket__modal">
          <h3 className="cancel-ticket__subtitle cancel-ticket__subtitle--capitalized">
            { `${ t('autoTransactions.autoTransaction') } -  ${ transactionName.replace(/([A-Z])/g, ' $1').trim() }` }
          </h3>
          <div className="cancel-ticket__comments">
            <input
              type="text"
              className="session__input session__input--value session__input--value--full"
              placeholder={ t('autoTransactions.amount') }
              onChange={ setAmount }
            />
          </div>
          {
            requireProperties &&
            <>
              <h3 className="cancel-ticket__subtitle">{ t('autoTransactions.selectTill') }</h3>
              <div className="cancel-ticket__comments">
                <select name="tills" className="cancel-ticket__options" onChange={ (e) => setSelectedTill(e.target.value) } >
                  <option />
                  {
                    _.map(_.sortBy(tillOptions, 'code'), (till) => {
                      return (
                        <option value={ till?.id }>{ `${ till.code } - ${ till.name }` }</option>
                      );
                    })
                  }
                </select>
              </div>
            </>
          }
          <div className="cancel-ticket__buttons">
            <Button
              type="button"
              text={ t('autoTransactions.confirm') }
              className="btn btn--cta"
              onClick={ onApprove }
            />
            <Button
              type="button"
              text={ t('autoTransactions.cancel') }
              className="btn btn--cta cancel-ticket__button cancel-ticket__button--cancel"
              onClick={ onClose }
            />
          </div>
        </div>
      </div>
    </MaterialModal>

  );
}

export default AutoTransactionModal;
